import React from 'react';
import Modal from 'react-modal';
import './index.scss';

export interface IAppModal {
  isOpen: boolean;
  onClose: (e: any) => void;
  hideCloseIcon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  children?: React.ReactNode;
  adjustToContent?: boolean;
  /** Extra classes on the modal panel, for callers needing to override the size preset. */
  className?: string;
}

const AppModal = ({
  isOpen,
  onClose,
  size = 'md',
  children,
  hideCloseIcon = false,
  adjustToContent = false,
  className
}: IAppModal) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName={`modalOverlay`}
      className={`modalContent ${size}${adjustToContent ? ' adjust-to-content' : ''}${
        className ? ` ${className}` : ''
      }`}
    >
      {!hideCloseIcon && (
        // Drawn inline rather than loaded from assets/images/close-icon.svg: as an
        // <img> it depends on the bundled asset URL resolving at runtime, and when
        // it doesn't the control degrades to a broken-image glyph plus alt text.
        // Inline it always paints, inherits the modal's text colour, and gets a
        // real button hit area instead of a 16px image.
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          className="tw-absolute tw-top-0 tw-right-0 tw-z-10 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-cursor-pointer tw-bg-transparent tw-border-0 tw-p-0 tw-text-primary-color"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M18 6L6 18" />
            <path d="M6 6L18 18" />
          </svg>
        </button>
      )}
      {children}
    </Modal>
  );
};

export default AppModal;
